<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    max-width="500px"
    :fullscreen="this.$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        small
        :title="$t('cancel')"
        @click="showDialog = true"
      >
        <v-icon size="24">mdi-cancel</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar flat tile class="flex-grow-0">
        <v-toolbar-title class="title">
          {{ $t("cancelBonus") }}
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="showDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="px-8 py-4">
        <span class="overline font-weight-bold">{{ $t("attention") }}</span>
        <br />
        <p class="body-2 pb-0 mb-2">
          {{ $t("areYouSureYouWantToCancelTheBonus") }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="showDialog = false">
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn color="primary" text @click="confirm">
          {{ $t("toConfirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
export default {
  props: ["dialog", "selectedItemBonusID"],
  data: () => ({
    showDialog: false,
    bonusID: "",
  }),
  created() {
    this.showDialog = this.dialog;
    this.bonusID = this.selectedItemBonusID;
  },
  methods: {
    confirm() {
      const endpoint =
        "https://gen.envrelease.com/administrator/bonus/cancelFreeRounds";

      const headers = {
        "Content-Type": "multipart/form-data",
        "Application-Authorization": this.$axios.defaults.headers.common[
          "Application-Authorization"
        ],
      };

      axios({
        method: "post",
        url: endpoint,
        data: this.$formdata({ id_bonus: this.bonusID }),
        headers,
      })
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });
        })
        .catch((error) => {
          this.$store.commit("setFeedbackSnack", {
            msg: error.response.data.messages.error,
            color: "warning",
          });

          //   console.log(error);
        })
        .finally(() => {
          this.showDialog = false;
          this.bonusID = "";
        });
    },
  },
};
</script>
